<template>
    <div class="wework-app-list-container">
        <p
            v-if="appListLoading"
            class="app-list-loading"
        >
            <v-spinner
                status="default"
                size="large"
            />
        </p>
        <div
            v-else
            class="wework-app-list"
        >
            <div
                v-for="(item, index) in appList"
                :key="index"
                class="app-list-box"
            >
                <div class="app-card-left">
                    <img
                        :src="item.square_logo"
                        class="app-card-left-icon"
                    >
                    <div class="app-card-left-content">
                        <h4 class="app-card-left-content-name">
                            <span>{{ item.name }}</span>
                            <v-tag
                                v-if="wxAppText(item.type) && item.status === 1"
                                :text="wxAppText(item.type)"
                                class="app-card-left-content-wx-tag"
                            />
                        </h4>
                        <span class="app-card-left-content-description">{{ item.describe }}</span>
                    </div>
                </div>
                <div class="app-card-right">
                    <div
                        v-if="item.status === 1"
                        class="app-config-btn-box"
                    >
                        <v-button
                            v-for="(btn, btnIndex) in item.config_button"
                            :key="btnIndex"
                            @click="onConfigBtnClick(btn)"
                            class="app-card-right-btn"
                        >
                            {{ btn.name }}
                        </v-button>
                    </div>
                    <v-button
                        v-if="item.status === 1"
                        :disabled="true"
                        class="app-card-right-btn"
                    >
                        已授权
                    </v-button>
                    <v-button
                        v-else
                        @click="authClick(item)"
                        status="primary"
                        class="app-card-right-btn"
                    >
                        去授权
                    </v-button>
                </div>
            </div>
        </div>
        <app-install-template
            ref="templateDialog"
            @install="authClick"
        />
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import { hideCloseBtn } from 'src/pages/mng/third_account/weworkCombine/api/dialog.js';
import AppInstallTemplate from '../../app-install-template';
import { getInstallCallBackByUrlParams, handleAppInstallUrl, handleInstallResult } from './api';

export default {
    components: {
        AppInstallTemplate,
    },

    data() {
        return {
            appListLoading: true,
            appList: [],
            appFlatMap: {},
        };
    },

    created() {
        const { suiteId, isInstallCallBack } = getInstallCallBackByUrlParams();

        if (isInstallCallBack && suiteId) {
            this.getAppList(suiteId);
        } else {
            this.getAppList();
        }
    },

    methods: {
        wxAppText(value) {
            if (value === 3) return '联合版';
            if (value === 4) return '独立版';
            return '';
        },
        getAppList(suiteId) {
            this.appListLoading = true;
            return Gateway.get('/v1/basic/corp/wework/appsList')
                .then((data) => {
                    const apps = (data && data.apps) || [];
                    const handleList = [];
                    apps.forEach((app) => {
                        const { type, agent, agent_group: agentGroup } = app || {};
                        const isGroup = type === 'app_group';
                        let item;

                        if (isGroup) {
                            item = agentGroup;

                            agentGroup.items.forEach((subItem) => {
                                this.setAppFlatMap({
                                    ...subItem,
                                    status: agentGroup.status,
                                    status_comment: agentGroup.status_comment,
                                });
                            });
                        } else {
                            item = agent;
                            this.setAppFlatMap(item);
                        }

                        if (item) {
                            handleList.push({
                                isGroup,
                                ...item,
                            });
                        }
                    });

                    this.appList = handleList;

                    if (suiteId) {
                        // 安装结果处理
                        handleInstallResult({
                            suiteId,
                            data: this.appFlatMap[suiteId],
                            isBind: this.isBind,
                            reInstallFn: () => {
                                this.authClick(this.appFlatMap[suiteId]);
                            },
                            refreshFn: () => {
                                this.getAppList(suiteId);
                            },
                        });
                    }

                    this.$forceUpdate();

                    this.appListLoading = false;
                })
                .catch((msg) => {
                    this.$message.error(msg || '获取应用列表错误');
                    this.appListLoading = false;
                });
        },

        authClick(item) {
            const { isGroup, type, suite_id: suiteId, install_url: installUrl } = item || {};
            if (isGroup) {
                this.$refs.templateDialog.show(item);
            } else if (suiteId.startsWith('dk')) {
                this.$router.push({ path: '/mng/weworkAccount/index/instead', query: { suiteId } });
            } else {
                if (!suiteId || !installUrl) {
                    this.$message.error('缺少授权必要信息');
                    return;
                }

                // type 1 和 2 之前是指的企微第三方应用（用来区别C和B侧）3是特指微信客服第三方应用（联合版）4 是微信客服独立版
                if (type === 4) {
                    this.wxkfAuth(suiteId, installUrl);
                } else {
                    this.installApp(suiteId, installUrl);
                }
            }
        },

        // 微信客服授权
        wxkfAuth(suiteId, authUrl) {
            const dialog = this.$confirm({
                title: '是否已完成微信客服授权？',
                confirmText: '完成',
                cancelText: '稍后再试',
                confirm: () => {
                    this.getAppList(suiteId);
                },
                cancel: () => {
                    this.getAppList(suiteId);
                },
            });

            window.open(authUrl);

            hideCloseBtn(dialog);
        },

        installApp(suiteId, installUrl) {
            const handledInstallUrl = handleAppInstallUrl(suiteId, installUrl);

            window.location.href = handledInstallUrl;
        },

        setAppFlatMap(item) {
            const { status, suite_id: suiteId } = item || {};

            if (suiteId) {
                this.appFlatMap[suiteId] = item;
            }

            if (status === 1) {
                this.isBind = true;
                this.$emit('installSuccess');
            }
        },

        onConfigBtnClick(btn) {
            const { url } = btn || {};

            if (url) {
                window.open(url);
            }
        },
    },
};
</script>
<style scoped lang="less">
@import './app-install-list.less';
</style>
<style lang="less">
.app-install-error-dialog {
    .v-dialog__container {
        max-width: 360px;
    }

    .v-dialog__title {
        white-space: pre-wrap;
    }

    &-text {
        font-size: 13px;

        &-left {
            text-align: left;
        }

        b {
            font-weight: normal;
            color: #ff8345;
        }

        a {
            text-decoration: underline;
        }
    }

    &-tip {
        margin-top: 3px;
        font-size: 12px;
        color: #78849e;

        &-right {
            text-align: right;
            padding-right: 10px;
        }
    }

    &.app-install-error-btn-150 {
        .v-button {
            width: 150px;
        }
    }

    &.app-install-error-btn-170 {
        .v-button {
            width: 170px;
        }
    }
}
</style>
